import { useModal, useRouter } from '@application/utils';
import type { BuyerChecklistModalItem } from '@presentation/components';
import { BuyerChecklistModal } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import { useMemo } from 'react';
import { singletonHook } from 'react-singleton-hook';

const init: ReturnType<typeof useBuyerChecklistModalSingleton> = {
  modalHook: {
    show: () => undefined,
    showFromClick: () => undefined,
    close: () => undefined,
    modal: {
      onCloseClick: undefined,
      open: false,
      position: [0, 0],
    },
  },
};

export const useBuyerChecklistModalSingleton = () => {
  const modalHook = useModal({});

  return modalHook;
};

export const useBuyerChecklistModal = singletonHook(init, useBuyerChecklistModalSingleton);

export const BuyerChecklistModalController = () => {
  const { modal } = useBuyerChecklistModal();
  const { translate } = useTranslation();
  const { routeLocationDescriptor } = useRouter();

  const items = useMemo(() => {
    const translations: { [key: string]: any } =
      translate('common.modals.buyerChecklist.items', { returnObjects: true }) ?? {};

    return Object.entries(translations).map(([key, item]) => {
      return {
        id: key,
        title: item.title,
        content: String(item.text).replace(
          '$articleHref',
          routeLocationDescriptor('article', { params: [] }).pathname ?? '',
        ),
      } as BuyerChecklistModalItem;
    });
  }, [routeLocationDescriptor, translate]);

  return <BuyerChecklistModal modal={modal} items={items} />;
};
